import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../../utils/api';
import { useToast } from '../../../context/ToastContext';

export default function AddSectionsToProgram() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { showToast } = useToast();

  const [form, setForm] = useState({
    title: '',
    descriptions: '',
    sequence: '',
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await api.addSectionsProgram({
        programId: id,
        title: form.title,
        descriptions: form.descriptions,
        sequence: form.sequence,
      });
      showToast('Section berhasil ditambahkan!', 'success');
      navigate(`/program/${id}`);
    } catch (err) {
      console.log(err);
      showToast('Gagal menambahkan section. Coba lagi nanti.', 'danger');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container py-4" style={{ maxWidth: '720px' }}>
      {/* Back Button */}
      <div className="mb-3">
        <button
          type="button"
          className="btn btn-white btn-sm rounded-circle shadow-sm border bg-white text-dark d-inline-flex align-items-center justify-content-center"
          style={{ width: '38px', height: '38px' }}
          onClick={() => navigate(-1)}
        >
          <i className="bi bi-arrow-left fs-5"></i>
        </button>
      </div>

      {/* HEADER */}
      <div className="mb-4">
        <h3 className="fw-bold">Tambah Tahapan Program</h3>
        <p className="text-muted">
          Gunakan form ini untuk menambah tahapan kegiatan (section) dalam satu program.
        </p>
      </div>

      <div className="card shadow-sm border-0 rounded-4">
        <div className="card-body p-4">
          <form onSubmit={handleSubmit}>
            {/* Title */}
            <div className="mb-3">
              <label htmlFor="title" className="form-label fw-semibold">
                Judul Tahapan <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                id="title"
                name="title"
                className="form-control rounded-3"
                placeholder="Contoh: Seleksi Berkas"
                value={form.title}
                onChange={handleChange}
                required
              />
              <small className="text-muted">
                Beri nama tahap yang jelas agar mudah dipahami oleh peserta.
              </small>
            </div>

            {/* Descriptions */}
            <div className="mb-3">
              <label htmlFor="descriptions" className="form-label fw-semibold">
                Deskripsi Tahapan <span className="text-danger">*</span>
              </label>
              <textarea
                id="descriptions"
                name="descriptions"
                className="form-control rounded-3"
                rows="3"
                placeholder="Tuliskan penjelasan singkat tentang tahapan ini..."
                value={form.descriptions}
                onChange={handleChange}
                required
              ></textarea>
              <small className="text-muted">
                Jelaskan apa yang dilakukan di tahap ini, misalnya proses seleksi atau kegiatan onboarding.
              </small>
            </div>

            {/* Sequence */}
            <div className="mb-4">
              <label htmlFor="sequence" className="form-label fw-semibold">
                Urutan Tahapan <span className="text-danger">*</span>
              </label>
              <input
                type="number"
                id="sequence"
                name="sequence"
                className="form-control rounded-3"
                placeholder="Contoh: 1"
                min="1"
                value={form.sequence}
                onChange={handleChange}
                required
              />
              <small className="text-muted">
                Tentukan posisi tahapan ini dalam urutan keseluruhan program (misalnya 1 untuk tahap pertama).
              </small>
            </div>

            {/* ACTION BUTTONS */}
            <div className="d-flex justify-content-end mt-3">
              <button
                type="button"
                className="btn btn-light rounded-pill me-2"
                onClick={() => navigate(-1)}
                disabled={loading}
              >
                Batal
              </button>

              <button
                type="submit"
                className="btn btn-primary rounded-pill px-4"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Menyimpan...
                  </>
                ) : (
                  <>
                    <i className="bi bi-save me-2"></i> Simpan
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
